<template>
  <div :class="containerClasses">
    <div
      v-if="label"
      class="Form-input__label"
    >
      {{ label }}
    </div>
    <div :class="{ 'Upload-input--has-file': fileUrl }" class="Upload-input">
      <input
        :id="uniqid"
        :disabled="disabled"
        type="file"
        class="Upload-input__input"
        ref="fileUploader"
        @change="updateFile"
        @click="resetUploader"
      />
      <label class="Upload-input__upload" :for="uniqid">
        <div v-if="isLoading" class="Upload-input__loader">
          <PreLoader />
        </div>
        <a v-if="fileName" @click="onFileDownload" class="Upload-input__file"><div v-if="downloading" class="Loader-holder"><PreLoader /></div><span v-else>{{ fileName }}</span></a>
        <span v-else>Välj fil</span>
        <button v-if="fileName" class="Upload-input__button" :disabled="disabled" @click="removeFile">Ta bort</button>
        <span v-else class="Upload-input__button">Ladda upp</span>
      </label>
    </div>

    <p v-if="inputFileName && errorMessage" class="Form-input__error">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import { helpers } from 'vuelidate/lib/validators'
import formInputMixin from './form-input-mixin'
import PreLoader from '@/components/PreLoader'

export default {
  name: 'UploadInput',
  components: {
    PreLoader
  },
  mixins: [formInputMixin],
  props: {
    value: {
      type: Object,
      required: false
    },
    fileName: {
      type: String,
      default: null
    },
    fileUrl: {
      type: String,
      default: null
    },
    allowedFileTypes: {
      type: Array,
      default: () => {
        return []
      }
    },
    maxFileSize: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    downloading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inputFileName: null,
      inputFileType: null,
      inputFileSize: null,
      isLoading: false
    }
  },
  validations () {
    const validations = {}
    if (this.allowedFileTypes && this.allowedFileTypes.length) {
      validations.inputFileType = {
        fileType: this.validateFileType(this.allowedFileTypes)
      }
    }
    if (this.maxFileSize) {
      validations.inputFileSize = {
        fileSize: this.validateFileSize(this.maxFileSize)
      }
    }
    return validations
  },
  computed: {
  },
  watch: {
    fileName: function (newVal, oldVal) {
      if (newVal === null || newVal) {
        this.isLoading = false
      }
    }
  },
  methods: {
    updateFile (event) {
      if (event.target.files && event.target.files.length) {
        this.isLoading = true
        this.inputFileName = event.target.files[0].name
        this.inputFileType = event.target.files[0].type
        this.inputFileSize = event.target.files[0].size
        if (!this.$v.$invalid) {
          this.$emit('change', event)
          this.$emit('input', event.target.files)
        }
        this.$v.$touch()
        this.$emit('touch')
      } else {
        this.removeFile()
      }
    },
    removeFile (event) {
      this.inputFileName = null
      this.inputFileType = null
      this.inputFileSize = null
      this.isLoading = true
      this.$v.$touch()
      this.$emit('touch')
      this.$emit('remove')
    },
    resetUploader (event) {
      this.$refs.fileUploader.value = ''
    },
    validateFileType: (allowedFileTypes) => {
      return helpers.withParams(
        { allowedFileTypes: allowedFileTypes },
        (input) => input && allowedFileTypes.filter(fileType => input.toLowerCase().indexOf(fileType.toLowerCase()) > -1).length
      )
    },
    validateFileSize: (maxFileSize) => {
      return helpers.withParams(
        { maxFileSize: maxFileSize },
        (input) => maxFileSize >= input
      )
    },
    onFileDownload (e) {
      e.preventDefault();
      this.$emit('download', this.fileName)
    }
  }
}
</script>
<style lang="scss" scoped>
.Upload-input__loader {
  position: absolute;
  top: 0;
  right: 0;
}
.Upload-input__loader ~ .Upload-input__button::before {
  background: none;
}

.Loader {
  width: 42px;
  overflow: hidden;
  margin-top: -10px;
}

.Upload-input__file {
  .Loader-holder {
    transform: translate(-4px, -10px);
    height: 42px;
    .Loader {
      position: static;
      display: inline-block;
      height: 24px;
    }
  }
}

</style>
